module.exports = __webpack_public_path__ + "img/0Q3B2213_L_BlackMatted_MockedUp.aa1e8c75.jpg";